<template>
  <div id="intro-description-content" class="d-lg-block">
    <h2
      id="catch-phrase"
      class="d-inline-block font-weight-bold mb-3 font-size-xxl"
    >
      {{ product.catch_phrase }}
    </h2>
    <br />
    <p class="d-inline-block styled-text mb-0" v-html="product_description"></p>
    <p
      class="styled-text"
      v-if="product.description"
      v-html="product.description"
    />
  </div>
</template>
<script>
import { useFeaturesStore } from '@/stores/features'
import { usePdpStore } from '@/stores/pdp'
import { mapState } from 'pinia'
export default {
  computed: {
    ...mapState(usePdpStore, { product: 'getApiProduct' }),
    ...mapState(useFeaturesStore, { featureEnabled: 'isFeatureEnabled' }),
    product_description() {
      if (
        this.featureEnabled('ai_short_descriptions') &&
        this.product.ai_short_description
      ) {
        return this.product.ai_short_description
      }
      return this.product.reason_why_two
    }
  }
}
</script>
